import { ClusterItemGroup } from '@common-modules/mediaDetails/models';
import { createNextState } from '@reduxjs/toolkit';

const checkIsAtLeastOneSubSegmentSelected = (
  subsegmentIds: readonly string[],
  selectedPolyGroups: Readonly<{ [key: string]: boolean | undefined }>
) => {
  for (const id of subsegmentIds) {
    if (selectedPolyGroups[id]) {
      return true;
    }
  }
  return false;
};

// ORIGINAL NOTE....
// NOTE: There can be a situation when an unselected group gets merged
// into a selected group. The right panel now has a single group that consist of multiple groups, where
// some of the groups are selected and some other groups are not selected, even though
// right panel shows them all as selected. This function makes sure that
// all of the groups that got merged into selected groups displayed as selected

// UPDATED NOTE (10/2025)...
// THis function "fixes" the selected status when groups segments merge due to changes in interpolation settings.
// It also handles an issue with a April 2025 release which causes intepolation subsegment to be "missing" from the selectedPolyGroups because a change in the subsegmentId formation (see VE-16193)
function fixSelectionForAdjacentSubsegments(
  initSelectedPolyGroups: { readonly [key: string]: boolean | undefined },
  groups: { [key: string]: ClusterItemGroup }
): { [key: string]: boolean | undefined } {
  // NOTE: We need to use createNextState here to return a new object because we are mutating Immer object
  // although Immer support mutating objects directly but we are construct a new object in return of reducer
  // see https://redux-toolkit.js.org/usage/immer-reducers#immer-usage-patterns
  const selectedPolyGroups = createNextState(
    initSelectedPolyGroups,
    (draftSelectedPolyGroups) => {
      for (const group of Object.values(groups)) {
        for (const segment of group.segments) {
          const subsegmentIds = segment.subsegmentIds;
          const isAtLeastOneSubGroupSelected =
            checkIsAtLeastOneSubSegmentSelected(
              subsegmentIds,
              draftSelectedPolyGroups
            );
          if (isAtLeastOneSubGroupSelected) {
            for (const subGroupId of subsegmentIds) {
              if (subGroupId !== undefined) {
                draftSelectedPolyGroups[subGroupId] = true;
              }
            }
          }
        }
      }
    }
  );

  return selectedPolyGroups;
}

export const adjustSelectedGroups = (
  selectedPolyGroups: { [key: string]: boolean | undefined },
  groups: { [key: string]: ClusterItemGroup }
): { [key: string]: boolean | undefined } => {
  if (!groups) {
    return selectedPolyGroups;
  }

  const selectedPolyGroupsNew = fixSelectionForAdjacentSubsegments(
    selectedPolyGroups,
    groups
  );

  return selectedPolyGroupsNew;
};
